export default __webpack_public_path__ + "static/media/page_not_found 1.755b5e87.svg";